// extracted by mini-css-extract-plugin
module.exports = {"Languages":"Languages_Languages__Eodnb","Icon":"Languages_Icon__2RYbF","LanguagesSelect":"Languages_LanguagesSelect__1iy2U","minimalist":"Languages_minimalist__wcTOX"};